// Static sidekick + Dreamer wordmark badge.
//
// Body geometry derived from AnimatableSidekick (Two.js renderer):
//   canvas 1024×1024, body centered at (512, 512)
//   BODY_RADIUS = 192, BODY_HANDLE = 106.04
//   At idle: gravity stretch ≈ 0.8, BODY_STRETCH_VALUE = 32
//     segment 0: r=192 (full circle, on top)      color #612CFF
//     segment 1: bottom vertex at y=217.6          color #B23ED3
//     segment 2: bottom vertex at y=243.2 (tail)   color #FC4DCC
//   Body rotation = 0 (tail points straight down).
//
// Eye geometry:
//   eyeGroup at (0, -52) from root center → canvas (512, 460)
//   left eye group at (-48, 0) → canvas (464, 460)
//   right eye group at (+48, 0) → canvas (560, 460)
//   Each eye path: 48×64 pill, centered via .center() → shift by (-24, -32)
//   → left eye translate(440, 428), right eye translate(536, 428)

      // <svg
      //   height="1.4em"
      //   viewBox="310 310 404 456"
      //   xmlns="http://www.w3.org/2000/svg"
      //   style={{ display: "inline-block", flexShrink: 0, position: "relative", top: "-0.175em" }}
      //   aria-hidden="true"
      // >
      //   <defs>
      //     <clipPath id="dreamer-badge-face">
      //       <circle cx="512" cy="512" r="192" />
      //     </clipPath>
      //   </defs>

      //   {/* Body segments — drawn back-to-front, all centered at (512, 512) */}
      //   <g transform="translate(512, 512)">
      //     {/* Segment 2: tail (pink), stretch=0.8 → bottom at y=243.2, handle=79.52 */}
      //     <path
      //       fill="#FC4DCC"
      //       d="M 192 0 C 192 106.04 79.52 243.2 0 243.2 C -79.52 243.2 -192 106.04 -192 0 C -192 -106.04 192 -106.04 192 0 Z"
      //     />
      //     {/* Segment 1: mid (purple-pink), stretch=0.8 → bottom at y=217.6, handle=92.8 */}
      //     <path
      //       fill="#B23ED3"
      //       d="M 192 0 C 192 106.04 92.8 217.6 0 217.6 C -92.8 217.6 -192 106.04 -192 0 C -192 -106.04 192 -106.04 192 0 Z"
      //     />
      //     {/* Segment 0: front circle (purple) */}
      //     <path
      //       fill="#612CFF"
      //       d="M 0 -192 C 106.04 -192 192 -106.04 192 0 C 192 106.04 106.04 192 0 192 C -106.04 192 -192 106.04 -192 0 C -192 -106.04 -106.04 -192 0 -192 Z"
      //     />
      //   </g>

      //   {/* Eyes, clipped to face circle */}
      //   <g clipPath="url(#dreamer-badge-face)">
      //     {/* Left eye: centroid at canvas (464, 460) → translate(464-24, 460-32) */}
      //     <path
      //       transform="translate(440, 428)"
      //       d="M24 0C44 0 48 17 48 32C48 47 44 64 24 64C4 64 0 47 0 32C0 17 4 0 24 0Z"
      //       fill="white"
      //     />
      //     {/* Right eye: centroid at canvas (560, 460) → translate(560-24, 460-32) */}
      //     <path
      //       transform="translate(536, 428)"
      //       d="M24 0C44 0 48 17 48 32C48 47 44 64 24 64C4 64 0 47 0 32C0 17 4 0 24 0Z"
      //       fill="white"
      //     />
      //   </g>
      // </svg>
 
export function DreamerBadge() {
  return (
    <a
      href="https://dreamer.com"
      target="_blank"
      rel="noopener noreferrer"
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: "0.35em",
        textDecoration: "none",
        color: "inherit",
        verticalAlign: "middle",
        lineHeight: 1,
      }}
    >
      {/* Sidekick — viewBox crops to body + tail with small padding */}
      {/* Sidekick SVG was here, see above */}

      {/* Wordmark — fill="currentColor" inherits terminal text color for light/dark */}
      <svg
        viewBox="0 0 815 158"
        height="0.8em"
        xmlns="http://www.w3.org/2000/svg"
        style={{ display: "inline-block", flexShrink: 0, position: "relative", top: "-0.12em" }}
        aria-label="Dreamer"
        role="img"
      >
        <path d="M274.89 157.511H274.88L274.884 157.51L274.89 157.511Z" fill="currentColor" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M388.021 41.4004C419.22 41.4005 433.45 57.5304 433.45 82.79V132.46C433.45 139.89 433.87 147.11 434.72 154.96H407.12C406.27 150.93 405.85 146.47 405.63 141.801C399.47 151.14 387.8 157.511 372.521 157.511C351.511 157.511 334.101 144.561 334.101 123.551C334.101 99.9908 352.99 91.2806 375.49 88.1006L395.23 85.3408C401.39 84.4908 404.99 81.5199 404.99 75.79L405.01 75.7803C405.01 68.3504 398.64 63.2609 387.601 63.2607C375.711 63.2607 369.34 69.4203 368.07 77.9102H338.99C341.32 57.9603 358.311 41.4004 388.021 41.4004ZM381.45 106.761C370.41 108.461 362.13 111.85 362.13 121.83C362.13 130.96 369.13 135.841 379.11 135.841L379.12 135.851C393.34 135.851 404.8 127.78 404.8 111.86V102.94L381.45 106.761Z"
          fill="currentColor"
        />
        <path d="M680.76 157.511H680.75L680.754 157.51L680.76 157.511Z" fill="currentColor" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M274.89 41.4004C305.67 41.4004 325.62 66.0204 325.62 97.4404C325.62 100.84 325.619 103.6 324.979 107.2H248.35C250.68 125.46 261.51 134.16 274.67 134.16C286.56 134.16 294.41 128.641 296.96 119.511H324.13C320.31 142.219 300.992 157.508 274.884 157.51C242.837 157.507 220.34 133.738 220.34 99.5605C220.34 65.3806 244.11 41.4005 274.89 41.4004ZM274.47 64.5303C260.67 64.5303 252.18 74.0802 249.21 87.46H296.97C296.55 75.1501 288.27 64.5303 274.47 64.5303Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M680.76 41.4004C712.6 41.4004 731.49 66.0204 731.49 97.4404C731.49 100.84 731.49 103.6 730.85 107.2H654.22C656.55 125.46 667.38 134.16 680.54 134.16C692.43 134.16 700.28 128.641 702.83 119.511H730C726.18 142.219 706.862 157.508 680.754 157.51C648.707 157.507 626.21 133.738 626.21 99.5605C626.21 66.2306 649.98 41.4005 680.76 41.4004ZM680.33 64.5303C666.32 64.5303 658.04 74.0802 655.07 87.46H702.83C702.41 75.1502 694.13 64.5303 680.33 64.5303Z"
          fill="currentColor"
        />
        <path
          d="M576.32 41.3896C599.67 41.3898 614.53 57.9497 614.53 82.3594V154.96H584.81V88.3096C584.81 75.5696 579.499 66.4492 566.979 66.4492C556.58 66.4494 547.24 74.5197 547.24 88.9492V154.97H517.52V88.3193C517.519 75.5797 512.21 66.4602 499.69 66.46C489.29 66.46 480.16 74.53 480.16 88.96V154.979H450.44V43.9395H480.16V57.9492C485.47 49.4594 496.72 41.3896 511.58 41.3896C523.89 41.3897 535.14 47.7595 541.3 57.9492C548.09 49.6693 559.56 41.3896 576.32 41.3896Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M55.1904 0C102.95 0.000182619 134.16 30.3506 134.16 77.4805C134.16 124.6 102.96 154.96 55.1904 154.96H0V0H55.1904ZM30.7695 128H53.7002C84.8999 128 102.309 108.26 102.31 77.4805C102.31 46.7005 84.9001 26.96 53.7002 26.96H30.7695V128Z"
          fill="currentColor"
        />
        <path d="M177.88 154.96H147.95V43.9404H177.88V154.96Z" fill="currentColor" />
        <path d="M773.09 43.9404V154.96H743.16V43.9404H773.09Z" fill="currentColor" />
        <path
          d="M200.7 41.75C210.956 41.7502 219.27 50.0645 219.27 60.3203C219.269 70.576 210.956 78.8895 200.7 78.8896C190.444 78.8896 182.13 70.5761 182.13 60.3203C182.13 50.0644 190.444 41.75 200.7 41.75Z"
          fill="currentColor"
        />
        <path
          d="M795.91 41.4004C806.166 41.4006 814.479 49.7149 814.479 59.9707C814.479 70.2264 806.166 78.5398 795.91 78.54C785.654 78.54 777.34 70.2265 777.34 59.9707C777.34 49.7148 785.654 41.4004 795.91 41.4004Z"
          fill="currentColor"
        />
      </svg>
    </a>
  );
}
